module.exports = "/images/vendor/flag-icon-css/flags/1x1/aw.svg?f159ec168ea083c41505dce64eb31923";